import site from '../helpers/site'

export default class ButtonHelper {
  constructor (button, innerElem) {
    this.siteName = site()

    this.button = button
    this.innerElem = innerElem

    // Default button styling
    this.bgColorDefault = 'brand'
    this.textColorDefault = 'white'

    // New (temporary) button styling - flip colors
    this.bgColorNew = 'white'
    this.textColorNew = 'brand'
  }

  setPendingState (text = window.variantStrings.addingToCart) {
    this.button.disabled = true

    // Product is being added to cart
    if (this.innerElem) {
      this.innerElem.innerText = text
      this.innerElem.style.animationPlayState = 'paused'
    }

    if (this.button) {
      this.button.classList.add(`bg-${this.bgColorNew}`)
      this.button.classList.add(`text-${this.textColorNew}`)
      this.button.classList.remove(`bg-${this.bgColorDefault}`)
      this.button.classList.remove(`text-${this.textColorDefault}`)
    }
  }

  setDoneState (text = window.variantStrings.addedToCart) {
    // Done adding to cart state
    if (this.innerElem) {
      this.innerElem.innerText = text
    }
  }

  resetState (text = window.variantStrings.addToCart) {
    this.button.disabled = false

    // if the button has a data-button-label attribute use that as text instead -
    // this is done for pages like promotions where button text may be custom
    if (this.button.dataset.buttonLabel) { text = this.button.dataset.buttonLabel }

    // Reset to initial state
    if (this.innerElem) {
      this.innerElem.innerText = text
      this.innerElem.style.animationPlayState = 'running'
    }

    if (this.button) {
      this.button.classList.add(`bg-${this.bgColorDefault}`)
      this.button.classList.add(`text-${this.textColorDefault}`)
      this.button.classList.remove(`bg-${this.bgColorNew}`)
      this.button.classList.remove(`text-${this.textColorNew}`)
    }
  }

  resetStateOnDelay (text = window.variantStrings.addToCart, delay = 3000) {
    // if the button has a data-button-label attribute use that as text instead -
    // this is done for pages like promotions where button text may be custom
    if (this.button.dataset.buttonLabel) { text = this.button.dataset.buttonLabel }

    setTimeout(() => {
      this.resetState(text)
    }, delay)
  }
}
